"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItem = _interopRequireDefault(require("../ListItem"));

var _ListWithNestedLists = _interopRequireDefault(require("../ListWithNestedLists"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ListWrapper = function ListWrapper(_ref) {
  var lists = _ref.lists,
      underline = _ref.underline;
  return lists.map(function (list, i) {
    return /*#__PURE__*/_react["default"].createElement(list.nestedItems ? _ListWithNestedLists["default"] : _ListItem["default"], _objectSpread({
      key: list.listItemText + i,
      underline: underline
    }, list));
  });
};

ListWrapper.defaultProps = {
  lists: []
};
ListWrapper.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  lists: _propTypes["default"].array.isRequired,
  underline: _propTypes["default"].bool
};
var _default = ListWrapper;
exports["default"] = _default;